// extracted by mini-css-extract-plugin
module.exports = {"hamburger-icon":"styles-m__hamburger-icon__2OxLR"};